import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Card, Title, Paragraph, Chip, useTheme } from 'react-native-paper';
import { formatPrice } from '../utils';

const MenuItemCard = ({ item, onPress }) => {
  const theme = useTheme();
  
  return (
    <Card 
      style={styles.card} 
      onPress={onPress}
      elevation={2}
    >
      <View style={styles.cardContentRow}>
        {item.imageUrl && (
          <Card.Cover 
            source={{ uri: item.imageUrl }}
            style={styles.cardImage}
          />
        )}
        <Card.Content style={styles.cardContent}>
          <Title style={styles.title}>{item.name}</Title>
          {item.description && (
            <Paragraph style={styles.description} numberOfLines={2}>
              {item.description}
            </Paragraph>
          )}
          
          <View style={styles.footer}>
            {item.price !== undefined && (
              <Chip style={styles.priceChip} mode="outlined">
                {formatPrice(item.price)} TL
              </Chip>
            )}
            {item.available === false && (
              <Chip 
                style={styles.availabilityChip} 
                mode="outlined"
                textStyle={{ color: '#e74c3c' }}
              >
                Tükenmiş
              </Chip>
            )}
          </View>
        </Card.Content>
      </View>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    marginVertical: 8,
    borderRadius: 8,
    overflow: 'hidden',
  },
  cardContentRow: {
    flexDirection: 'row',
  },
  cardImage: {
    height: 100,
    width: 100,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  cardContent: {
    paddingVertical: 12,
    flex: 1,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  description: {
    marginTop: 4,
    opacity: 0.7,
    fontSize: 12,
  },
  footer: {
    flexDirection: 'row',
    marginTop: 8,
    flexWrap: 'wrap',
  },
  priceChip: {
    marginRight: 8,
    height: 24,
  },
  availabilityChip: {
    height: 24,
    borderColor: '#e74c3c',
  },
});

export default MenuItemCard;
